import firebase from 'firebase/app';
import 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyDz9_DFFVR501GhNjsQ1LjvzE973Z2OF6o",
    authDomain: "hlj1-seerapu.firebaseapp.com",
    projectId: "hlj1-seerapu",
    storageBucket: "hlj1-seerapu.firebasestorage.app",
    messagingSenderId: "900337971794",
    appId: "1:900337971794:web:6ba249539e4b1f7eb5258b",
    measurementId: "G-M3PM6NBN4S"
};

const app = firebase.apps.find(item => item.name === 'phone-auth') ||
    firebase.initializeApp(firebaseConfig, 'phone-auth');
export const auth = app.auth();
export const RecaptchaVerifier = firebase.auth.RecaptchaVerifier;
export const signInWithPhoneNumber = (authInstance, phoneNumber, appVerifier) => {
    return authInstance.signInWithPhoneNumber(phoneNumber, appVerifier);
};

export default firebase;
